import { render, staticRenderFns } from "./IconTier.vue?vue&type=template&id=1fbc7ab1"
import script from "./IconTier.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconTier.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports